export { default } from './LoadingSpinner';



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/LoadingSpinner/index.js